const takeEveryUntil = (rows: number[]) => {
  const arr: number[] = [rows[0]];
  let last = rows[0];
  for (let i = 1; i < rows.length; i++) {
    if (rows[i] - 1 === last) {
      arr.push(rows[i]);
    } else {
      break;
    }
    last = rows[i];
  }
  return arr;
};

type Args = {
  rows: number[];
  ranges: number[][];
  index: number;
};

const getErrorRowRanges = ({ rows, ranges = [], index }: Args) => {
  const range = takeEveryUntil(rows.slice(index));
  return {
    rows,
    ranges: [...ranges, range],
    index: index + range.length,
  };
};

export const getRowValidationError = (rows: number[]) => {
  if (rows.length === 0) return null;

  let current = getErrorRowRanges({
    rows,
    ranges: [],
    index: 0,
  });

  let canContinue = true;

  while (canContinue) {
    const next = getErrorRowRanges(current);
    const lastRange = next.ranges[next.ranges.length - 1];
    if (typeof lastRange[0] === 'undefined') {
      canContinue = false;
      break;
    }
    current = next;
  }

  return {
    message: `To save, fix ${rows.length} incomplete transactions`,
    errorRowRanges: current.ranges,
  };
};
